import { useEffect } from 'react';
import './Contact.css';

const Contact = () => {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="contact-page">

            {/* ── Hero ── */}
            <div className="contact-hero">
                <div className="container">
                    <div className="contact-hero-icon"><i className="fas fa-envelope-open-text"></i></div>
                    <h1 className="contact-hero-title">Contact Us</h1>
                    <p className="contact-hero-sub">We'd love to hear from you. Send us a message and we'll respond shortly.</p>
                </div>
            </div>

            {/* ── Main card ── */}
            <div className="container contact-bottom-pad">
                <div className="contact-main-card">

                    {/* Form */}
                    <div className="contact-form-panel">
                        <span className="contact-panel-label">Send a message</span>
                        <h2 className="contact-panel-title">Drop us a Feedback</h2>
                        <p className="contact-panel-sub">We'll get in touch as soon as possible.</p>

                        <div className="contact-input-row">
                            <input type="text" className="contact-input" placeholder="Your name" />
                            <input type="email" className="contact-input" placeholder="Your email" />
                        </div>
                        <textarea className="contact-textarea" placeholder="Your message" rows={5}></textarea>
                        <button className="contact-send-btn">
                            <i className="fas fa-paper-plane"></i> Send Message
                        </button>
                    </div>

                    {/* Divider */}
                    <div className="contact-divider"></div>

                    {/* Info */}
                    <div className="contact-info-panel">

                        <div className="contact-info-block">
                            <div className="contact-info-icon-wrap"><i className="fas fa-map-marker-alt"></i></div>
                            <p className="contact-info-heading">Address</p>
                            <a href="https://maps.app.goo.gl/FcBjcKZi6T9Y8wMj7" target="_blank" rel="noreferrer" className="contact-info-link">
                                Kalyan, Kongaon, Maharashtra 421311
                            </a>
                        </div>

                        <div className="contact-info-block">
                            <div className="contact-info-icon-wrap"><i className="fas fa-envelope"></i></div>
                            <p className="contact-info-heading">Email</p>
                            <a href="mailto:pentadeco@gmail.com" className="contact-info-link">pentadeco@gmail.com</a>
                        </div>

                        <div className="contact-info-block">
                            <div className="contact-info-icon-wrap"><i className="fab fa-whatsapp"></i></div>
                            <p className="contact-info-heading">WhatsApp / Phone</p>
                            <a href="tel:+917738494171" className="contact-info-link">+91 77384 94171</a>
                            <a href="tel:+918433551012" className="contact-info-link">+91 84335 51012</a>
                            <a href="tel:+919273158535" className="contact-info-link">+91 92731 58535</a>
                        </div>

                    </div>
                </div>

                {/* ── Map ── */}
                <div className="contact-map-wrap">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.6732548541404!2d73.1123242!3d19.2467707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be797339660dae3%3A0x9b0ccec382d87ae!2sPENTADECO%20-%20Home%20%26%20Kitchen%20Decor!5e1!3m2!1sen!2sin!4v1757854264980!5m2!1sen!2sin"
                        width="100%"
                        height="420"
                        style={{ border: 0 }}
                        title="Google Maps — Pentadeco"
                        referrerPolicy="no-referrer-when-downgrade"
                        loading="lazy"
                    ></iframe>
                </div>
            </div>

        </div>
    );
};

export default Contact;
